import { Input } from 'reactstrap';
import { MaximumAge, MinimumAge } from '../../../../Constant';
import { ChangeEvent } from 'react';

interface tableSearchBarpropsType{
  filteredData:(event: ChangeEvent<HTMLInputElement>) => void
}

const TableSearchBar = ({filteredData}:tableSearchBarpropsType) => {
  return (
    <div className="table-responsive dataTables_wrapper me-0">
      <table>
        <tbody className="dataTables_filter">
          <tr>
            <td>{MinimumAge}</td>
            <td>
              <Input onChange={filteredData} type="search" name="minValue" />
            </td>
          </tr>
          <tr>
            <td>{MaximumAge}</td>
            <td>
              <Input onChange={filteredData} type="search" name="maxValue" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default TableSearchBar;
